import { render, staticRenderFns } from "./ppQueue.vue?vue&type=template&id=2ea6ca2c&scoped=true&"
import script from "./ppQueue.vue?vue&type=script&lang=js&"
export * from "./ppQueue.vue?vue&type=script&lang=js&"
import style0 from "./ppQueue.vue?vue&type=style&index=0&id=2ea6ca2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6ca2c",
  null
  
)

export default component.exports